var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSavedSnip = function SvgSavedSnip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "4 7 40 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFAFA",
    d: "M12 8h24a7 7 0 0 1 7 7v12a7 7 0 0 1-7 7H20l-5.8 5.1c-.8.7-2.2.1-2.2-1V34a7 7 0 0 1-7-7V15a7 7 0 0 1 7-7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 14,
    x: 11,
    y: 14,
    fill: "#4D8DF6",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D2D2D2",
    strokeDasharray: "2 3.4",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "M19 17h18M19 25h13",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(10,10,10,0.12)",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 8h24a7 7 0 0 1 7 7v12a7 7 0 0 1-7 7H20l-5.8 5.1c-.8.7-2.2.1-2.2-1V34a7 7 0 0 1-7-7V15a7 7 0 0 1 7-7Z"
  })));
};
export default SvgSavedSnip;